import { useMutation, useQuery } from 'react-query'
import request from '../request'

export const useGenerateReports = () => {
  return useMutation(
    ({
      data,
    }: {
      data: {
        agency_id?: string
        dealership_ids: Array<{ label: string; value: number }>
        date: string
      }
    }) =>
      request({
        url: `/agencies/${data.agency_id}/reports/generate`,
        method: 'POST',
        data,
      }),
  )
}
